import { Hero } from "@/components/nyla/Hero";
import { Intro } from "@/components/nyla/Intro";
import { WaterCounter } from "@/components/nyla/WaterCounter";
import { Explore } from "@/components/nyla/Explore";
import { Blog } from "@/components/nyla/Blog";
import { Faq } from "@/components/nyla/Faq";
import { CtaBanner } from "@/components/nyla/CtaBanner";
import { SEO } from "@/components/nyla/SEO";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Nyla Air Water — Born from Air. Perfected by Nature.",
    url: "https://nylaairwater.earth/",
    description:
      "Premium bottled water gathered from atmospheric moisture. Pure, mineral-enriched, sustainable hydration without taking a drop from the ground.",
    inLanguage: "en-IN",
    isPartOf: { "@type": "WebSite", url: "https://nylaairwater.earth/", name: "Nyla Air Water" },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://nylaairwater.earth/" },
    ],
  },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        absoluteTitle
        title="Nyla Air Water — Where Nature Meets Purity"
        description="Nyla Air Water — premium bottled water born from atmospheric moisture. Pure, mineral-enriched, sustainable hydration crafted in Hyderabad, India."
        path="/"
        keywords="Nyla Air Water, air water, atmospheric water India, alkaline water, pH balanced water, sparkling water India, premium bottled water, sustainable water brand, Hyderabad"
        jsonLd={homeJsonLd}
      />
      <WaterCounter />
      <Hero />
      <Intro />
      <Explore />
      <Blog limit={3} />
      <Faq />
      <CtaBanner />
    </div>
  );
}
